import React from "react";
import styles from "./CareerBoxforItem.module.scss";
import cx from "classnames";

function CareerBoxforItem({ children, boxStyle }) {
  return <div className={cx(styles.box, boxStyle)}>{children}</div>;
}

export default CareerBoxforItem;
